import { render } from "./LeadershipMessageView.vue?vue&type=template&id=f1a99f6a"
import script from "./LeadershipMessageView.vue?vue&type=script&lang=js"
export * from "./LeadershipMessageView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__